var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"white"}},[_c('v-row',[_vm._v(" hola ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }